import React, { useState } from 'react';
import BuildIcon from '@mui/icons-material/Build';
import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';
import SnackBar from 'src/components/SnackBar/SnackBar';

const TabThree = ({
  commonPermissionsProject,
  setcommonPermissionsProject,
  generalDetailsProject,
  setgeneralDetailsProject,
  timeEstimations,
  setTimeEstimations,
  financialDetails,
  setFinancialDetails,
  onClickAll,
  stakeholders,
  setStakeholders,
  isEdit
}) => {
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Common Permissions
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-common-edit-all"
            control={
              <Checkbox
                id="projects-common-edit-all"
                checked={commonPermissionsProject.every((dash) => dash.value)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(
                    commonPermissionsProject,
                    'common',
                    setcommonPermissionsProject,
                    e
                  )
                }
              />
            }
            label="All"
          />
        </Grid>
        {commonPermissionsProject.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={commonPermissionsProject[index]?.value}
                    onChange={(e) => {
                      let items = [...commonPermissionsProject];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setcommonPermissionsProject(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            General Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-general-edit-all"
            control={
              <Checkbox
                id="projects-general-edit-all"
                disabled={isEdit}
                checked={generalDetailsProject.every((dash) => dash.view)}
                onClick={(e) =>
                  onClickAll(
                    generalDetailsProject,
                    'status',
                    setgeneralDetailsProject,
                    e
                  )
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={generalDetailsProject.every((dash) => dash.edit)}
            disabled={isEdit}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(
                  generalDetailsProject,
                  'edit',
                  setgeneralDetailsProject,
                  e
                );
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {generalDetailsProject.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={generalDetailsProject[index]?.view}
                    onChange={(e) => {
                      let items = [...generalDetailsProject];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setgeneralDetailsProject(items);
                    }}
                  />
                }
                //rename only frontend side Customer to Client
                label={data.name === "Customer" ? "Client" : data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissionsProject?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...generalDetailsProject];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      if (!isEdit) setgeneralDetailsProject(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Stakeholders
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-stakeholder-edit-all"
            control={
              <Checkbox
                id="projects-stakeholder-all"
                checked={stakeholders.every((dash) => dash.view)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(stakeholders, 'status', setStakeholders, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={stakeholders.every((dash) => dash.edit)}
            disabled={isEdit}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(stakeholders, 'edit', setStakeholders, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {stakeholders.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={stakeholders[index]?.view}
                    onChange={(e) => {
                      let items = [...stakeholders];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setStakeholders(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissionsProject?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...stakeholders];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      if (!isEdit) setStakeholders(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Financial Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-financial-edit-all"
            control={
              <Checkbox
                id="projects-financial-edit-all"
                disabled={isEdit}
                checked={financialDetails.every((dash) => dash.view)}
                onClick={(e) =>
                  onClickAll(financialDetails, 'status', setFinancialDetails, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={financialDetails.every((dash) => dash.edit)}
            disabled={isEdit}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(financialDetails, 'edit', setFinancialDetails, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {financialDetails.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={financialDetails[index]?.view}
                    onChange={(e) => {
                      let items = [...financialDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setFinancialDetails(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissionsProject?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...financialDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      if (!isEdit) setFinancialDetails(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Time Estimations
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="projects-form-time-edit-all"
            control={
              <Checkbox
                id="projects-time-edit-all"
                checked={timeEstimations.every((dash) => dash.view)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(timeEstimations, 'status', setTimeEstimations, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            checked={timeEstimations.every((dash) => dash.edit)}
            disabled={isEdit}
            onClick={(e) => {
              if (
                commonPermissionsProject?.filter(
                  (comm) => comm?.name === 'Edit'
                )[0]?.value
              ) {
                onClickAll(timeEstimations, 'edit', setTimeEstimations, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {timeEstimations.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={timeEstimations[index]?.view}
                    onChange={(e) => {
                      let items = [...timeEstimations];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setTimeEstimations(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) &&
                data.name !== 'Project Actual Effort Status' &&
                data.name !== 'Remaining Effort' &&
                data.name !== 'Project Performance Effort Overrun' &&
                data.name !== 'Recognized Revenue' && (
                  <BuildIcon
                    onClick={() => {
                      if (
                        commonPermissionsProject?.filter(
                          (comm) => comm?.name === 'Edit'
                        )[0]?.value
                      ) {
                        let items = [...timeEstimations];
                        let item = { ...items[index] };
                        item = {
                          category: data.category,
                          edit: !data.edit,
                          name: data.name,
                          tab: data.tab,
                          view: data.view
                        };
                        items[index] = item;
                        if (!isEdit) setTimeEstimations(items);
                      } else {
                        setSnackBarMessage(
                          'You cannot give edit permissions without checking the Edit checkbox'
                        );
                        setSnackbarSeverity('error');
                        setSnackBarOpen(true);
                      }
                    }}
                    sx={{
                      fontSize: '0.8rem',
                      color: `${data.edit === false ? 'gray' : 'blue'}`
                    }}
                  />
                )}
            </Grid>
          );
        })}
      </Grid>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
    </>
  );
};

export default TabThree;
